/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `MD` - Republic of Moldova
 * * `EU` - European Union
 */
export enum CascoTerritoryType {
  MD = 'MD',
  EU = 'EU',
}
